<script lang="ts">
export default {
    name: 'ProductListItemInfo',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import ProductListItemInfoElement from '@/components/app/product/list/item/info/element.vue';

const props = defineProps<{
    list: Array<{
        condition?: boolean;
        component?: {
            is?: object;
            props?: Record<string, unknown>;
        };
        value: unknown;
        class?: unknown;
        label?: string;
        icon?: {
            name?: string;
            class?: string;
        };
    }>;
}>();

const displayList = computed(() => props.list.filter(item => item.condition ?? true));
</script>

<template>
    <div class="flex-1 text-gray-500">
        <template
            v-for="(item, index) in displayList"
        >
            <component
                v-if="item.component"
                v-bind="item.component.props ?? {}"
                :key="index"
                :is="item.component.is"
            />
            <product-list-item-info-element
                v-else
                :key="index"
                :data="item"
            />
        </template>
    </div>
</template>
